import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  private baseUrl = environment.apiUrl;
  private baseUrl_TYPE2 = environment.apiUrl + '/type2_sd1';
  private baseUrl_SD1 = environment.apiUrl + '/sd1';
  private baseUrl_MDU = environment.apiUrl + '/mdu';
  private baseUrl_N2P = environment.apiUrl+'/n2p';
  private baseUrl_HD = environment.apiUrl+'/hd';
  private baseUrl_Aerial = environment.apiUrl+'/aerial';
  private dataSubject = new BehaviorSubject<any>(null);

  constructor(private http: HttpClient) { }

  // Observable to which components can subscribe
  data$ = this.dataSubject.asObservable();

  shareData(data: any) {
    this.dataSubject.next(data);
  }
  //TODO: rename createmap to initiatemap 
  initiatemapinfodesign(queryString: string): Observable<any> {
    const url = `${this.baseUrl}/initiatemapinfodesign` + queryString;
    console.log(url)
    return this.http.post(url, {});
  } 

  selectEndEquipment(dataToSend: any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const url = `${this.baseUrl}/selectendequipment`
    return this.http.post(url, dataToSend, { headers })
  }
  bjlpathoverwrite(dataToSend: any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const url = `${this.baseUrl}/bjlpathoverwrite`
    return this.http.post(url, dataToSend, { headers })
  }
  selectjlStructure(dataToSend: any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const url = `${this.baseUrl}/selectjlstructure`
    return this.http.post(url, dataToSend, { headers })
  }
  //TODO : add jl_type field 
  selectUpstremEquipment(dataToSend: any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const url = `${this.baseUrl}/selectupstreamequipment`
    return this.http.post(url, dataToSend, { headers })
  }
  //TODO : remove api and add into  selectupstreamequipment with jl_type 
  selectAjlUpstremEquipment(dataToSend: any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const url = `${this.baseUrl}/selectupstreamequipment`
    return this.http.post(url, dataToSend, { headers })
  }
  selectStructure(dataToSend: any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const url = `${this.baseUrl}/selectstructure`
    return this.http.post(url, dataToSend, { headers })
  }
  selectEquip(dataToSend: any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const url = `${this.baseUrl}/selectequipment`
    return this.http.post(url, dataToSend, { headers })
  }
  uploadmduosp(dataToSend: any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const url = `${this.baseUrl}/uploadmduosp`
    return this.http.post(url, dataToSend, { headers })
  }
  onSelectPath(dataToSend: any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const url = `${this.baseUrl}/selectpath`
    return this.http.post(url, dataToSend, { headers })
  }
  onadrcall(dataToSend: any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const url = `${this.baseUrl}/uploadadr`
    return this.http.post(url, dataToSend, { headers })
  }

  onAlternatePath(dataToSend: any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const url = `${this.baseUrl}/alternatepath`
    return this.http.post(url, dataToSend, { headers })
  }

  onInitiateDfn(dataToSend: any, queryString: any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const url = `${this.baseUrl}/initiatedfnmapinfodesign` + queryString
    return this.http.post(url, dataToSend, { headers })
  }

  onSelectDfnPath(dataToSend: any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const url = `${this.baseUrl}/selectdfnpath`
    return this.http.post(url, dataToSend, { headers })
  }

  // remove api , and add in selectjlstructure
  onSelectDfnBjlStr(dataToSend: any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const url = `${this.baseUrl}/selectjlstructure`
    return this.http.post(url, dataToSend, { headers })
  }

  getFiles(): Observable<any> {
    return this.http.get(`${this.baseUrl}/files`);
  }

  uploadFile(dataToSend: any): Observable<any> {
    //const headers = new HttpHeaders({ 'Content-Type': 'multipart/form-data' });
    const url = `${this.baseUrl}/uploadfile`
    return this.http.post(url, dataToSend)
  }

  ///// ADR APIs ////
  initiatemapinfodesignadr(queryString: string): Observable<any> {
    const url = `${this.baseUrl}/initiatemapinfodesignadr` + queryString;
    console.log(url)
    return this.http.post(url, {});
  }

  onInitiateDfnAdr(dataToSend: any, queryString: any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const url = `${this.baseUrl}/initiatedfnmapinfodesignadr` + queryString
    return this.http.post(url, dataToSend, { headers })
  }

  uploadmduospAdr(dataToSend: any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const url = `${this.baseUrl}/uploadmduospadr`
    return this.http.post(url, dataToSend, { headers })
  }

  selectEquipAdr(dataToSend: any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const url = `${this.baseUrl}/selectequipmentadr`
    return this.http.post(url, dataToSend, { headers })
  }

  selectStructureAdr(dataToSend: any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const url = `${this.baseUrl}/selectstructureadr`
    return this.http.post(url, dataToSend, { headers })
  }

  receiveAdrcall(dataToSend: any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const url = `${this.baseUrl}/receiveadr`
    return this.http.post(url, dataToSend, { headers })
  }

  selectUpstremEquipmentAdr(dataToSend: any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const url = `${this.baseUrl}/selectupstreamequipmentadr`
    return this.http.post(url, dataToSend, { headers })
  }

  selectBjl(dataToSend: any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const url = `${this.baseUrl}/selectbjl`
    return this.http.post(url, dataToSend, { headers })
  }


  /* SD1 APIs */
  //TODO: rename createmap to initiatemap 
  initiatemapinfodesignSD1(queryString: string): Observable<any> {
    const url = `${this.baseUrl_SD1}/initiatemapinfodesign` + queryString;
    console.log(url)
    return this.http.post(url, {});
  } 
  selectBjlSD1(dataToSend: any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const url = `${this.baseUrl_SD1}/selectbjl`
    return this.http.post(url, dataToSend, { headers })
  }

  selectSmpLocationSD1(dataToSend: any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const url = `${this.baseUrl_SD1}/selectsmplocations`
    return this.http.post(url, dataToSend, { headers })
  }

  selectSmpStructure(dataToSend: any,msg:string): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let url = '';
    if (msg == 'select smp structure') {
      url = `${this.baseUrl_SD1}/selectsmpstructure`;
    }
    else {
      url = `${this.baseUrl_SD1}/selectbjlstructure`;
    }
    return this.http.post(url, dataToSend, { headers })
  }
  
  selectBJLStructure(dataToSend: any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const url = `${this.baseUrl_SD1}/selectbjlstructure`
    return this.http.post(url, dataToSend, { headers })
  }

  selectUpstreamStructure(dataToSend: any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const url = `${this.baseUrl_SD1}/selectupstreamequipment`
    return this.http.post(url, dataToSend, { headers })
  }

  generateSd1Output(dataToSend: any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const url = `${this.baseUrl_SD1}/generatesd1output`
    return this.http.post(url, dataToSend, { headers })
  }

  bjlpathoverwriteSD1(dataToSend: any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const url = `${this.baseUrl_SD1}/bjlpathoverwrite`
    return this.http.post(url, dataToSend, { headers })
  }
  onadrcallSD1(dataToSend: any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const url = `${this.baseUrl_SD1}/uploadadr`
    return this.http.post(url, dataToSend, { headers })
  }
  onInitiateDfnSD1(dataToSend: any, queryString: any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const url = `${this.baseUrl_SD1}/initiatemapinfodesign` + queryString
    return this.http.post(url, dataToSend, { headers })
  }

  initiateBOMBOQ(dataToSend: any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const url = `${this.baseUrl_SD1}/initiateBOMBOQ`
    return this.http.post(url, dataToSend, { headers })
  }
 

  /* MDU APIs */
  initiatemapinfodesignMDU(queryString: string): Observable<any> {
    const url = `${this.baseUrl_MDU}/initiatemdumapinfodesign` + queryString;
    console.log(url)
    return this.http.post(url, {});
  } 


  /* HD-LFN APIs */
  //TODO: rename createmap to initiatemap

  initiatemapinfodesignHDLFN(queryString: string): Observable<any> {
    const url = `${this.baseUrl_HD}/initiatemapinfodesignhd` + queryString;
    console.log(url)
    return this.http.post(url, {});
  } 

  selectBjlHD(dataToSend: any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const url = `${this.baseUrl_HD}/selectbjl`
    return this.http.post(url, dataToSend, { headers })
  }

  selectSmpLocationHD(dataToSend: any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const url = `${this.baseUrl_HD}/selectsmplocations`
    return this.http.post(url, dataToSend, { headers })
  }

  selectSmpStructureHD(dataToSend: any,msg:string): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let url = '';
    if (msg == 'select smp structure') {
      url = `${this.baseUrl_HD}/selectsmpstructure`;
    }
    else {
      url = `${this.baseUrl_HD}/selectbjlstructure`;
    }
    return this.http.post(url, dataToSend, { headers })
  }

  selectBJLStructureHD(dataToSend: any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const url = `${this.baseUrl_HD}/selectbjlstructure`
    return this.http.post(url, dataToSend, { headers })
  }

  selectUpstreamStructureHD(dataToSend: any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const url = `${this.baseUrl_HD}/selectupstreamequipment`
    return this.http.post(url, dataToSend, { headers })
  }

  generateHDOutput(dataToSend: any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const url = `${this.baseUrl_HD}/generatehdoutput`
    return this.http.post(url, dataToSend, { headers })
  }

  bjlpathoverwriteHD(dataToSend: any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const url = `${this.baseUrl_HD}/bjlpathoverwrite`
    return this.http.post(url, dataToSend, { headers })
  }

  onadrcallHD(dataToSend: any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const url = `${this.baseUrl_HD}/uploadadr`
    return this.http.post(url, dataToSend, { headers })
  }

  pitBjlDistancehd(dataToSend: any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const url = `${this.baseUrl_HD}/pitbjldistance`
    return this.http.post(url, dataToSend, { headers })
  }

  pitSizeUpdatehd(dataToSend: any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const url = `${this.baseUrl_HD}/pitsizeupdate`
    return this.http.post(url, dataToSend, { headers })
  }

  skipUnwatedLochd(dataToSend: any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const url = `${this.baseUrl_HD}/skipunwatedlocations`
    return this.http.post(url, dataToSend, { headers })
  }

  sheet_validation_hd(dataToSend: any, options?: any): Observable<any> {
  const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  const url = `${this.baseUrl_HD}/sheet_validation`;
  const httpOptions = { headers, ...options };
  return this.http.post(url, dataToSend, httpOptions);
  }

  newhdBjl(dataToSend: any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const url = `${this.baseUrl_HD}/new_bjl`
    return this.http.post(url, dataToSend, { headers })
  }

  callhdFMB(dataToSend: any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const url = `${this.baseUrl_HD}/selectfmblocations`
    return this.http.post(url, dataToSend, { headers })
  }

  checkBjlCapacityHD(dataToSend: any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const url = `${this.baseUrl_HD}/checkbjlcapacityhd`
    return this.http.post(url, dataToSend, { headers })
  }

  newSPLHD(dataToSend: any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const url = `${this.baseUrl_HD}/view_smp_creation`
    return this.http.post(url, dataToSend, { headers })
  }
  
  newFJLSPLHD(dataToSend: any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const url = `${this.baseUrl_HD}/new_fjl_spl_creation`
    return this.http.post(url, dataToSend, { headers })
  }

  onInitiateDfnHD(dataToSend: any, queryString: any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const url = `${this.baseUrl_HD}/initiatemapinfodesignhd` + queryString
    return this.http.post(url, dataToSend, { headers })
  }

  
  /* N2P APIs */
  //TODO: rename createmap to initiatemap 
  initiatemapinfodesignN2P(queryString: string): Observable<any> {
    const url = `${this.baseUrl_N2P}/initiatemapinfodesign` + queryString;
    console.log(url)
    return this.http.post(url, {});
  } 

  selectBjlN2P(dataToSend: any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const url = `${this.baseUrl_N2P}/selectbjl`
    return this.http.post(url, dataToSend, { headers })
  }

  selectSmpLocationN2P(dataToSend: any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const url = `${this.baseUrl_N2P}/selectsmplocations`
    return this.http.post(url, dataToSend, { headers })
  }

  selectSmpStructureN2P(dataToSend: any,msg:string): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    let url = '';
    if (msg == 'select smp structure') {
      url = `${this.baseUrl_N2P}/selectsmpstructure`;
    }
    else {
      url = `${this.baseUrl_N2P}/selectbjlstructure`;
    }
    return this.http.post(url, dataToSend, { headers })
  }

  selectBJLStructureN2P(dataToSend: any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const url = `${this.baseUrl_N2P}/selectbjlstructure`
    return this.http.post(url, dataToSend, { headers })
  }

  selectUpstreamStructureN2P(dataToSend: any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const url = `${this.baseUrl_N2P}/selectupstreamequipment`
    return this.http.post(url, dataToSend, { headers })
  }

  generateN2pOutput(dataToSend: any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const url = `${this.baseUrl_N2P}/generaten2poutput`
    return this.http.post(url, dataToSend, { headers })
  }

  bjlpathoverwriteN2P(dataToSend: any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const url = `${this.baseUrl_N2P}/bjlpathoverwrite`
    return this.http.post(url, dataToSend, { headers })
  }

  onadrcallN2P(dataToSend: any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const url = `${this.baseUrl_N2P}/uploadadr`
    return this.http.post(url, dataToSend, { headers })
  }

  onInitiateDfnN2P(dataToSend: any, queryString: any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const url = `${this.baseUrl_N2P}/initiatemapinfodesign_dfn` + queryString
    return this.http.post(url, dataToSend, { headers })
  }

  pitBjlDistance(dataToSend: any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const url = `${this.baseUrl_N2P}/pitbjldistance`
    return this.http.post(url, dataToSend, { headers })
  }

  skipUnwatedLoc(dataToSend: any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const url = `${this.baseUrl_N2P}/skipunwatedlocations`
    return this.http.post(url, dataToSend, { headers })
  }
  
  pitSizeUpdate(dataToSend: any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const url = `${this.baseUrl_N2P}/pitsizeupdate`
    return this.http.post(url, dataToSend, { headers })
  }

  callFnB(dataToSend: any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const url = `${this.baseUrl_N2P}/selectfmblocations`
    return this.http.post(url, dataToSend, { headers })
  }


  createTrenchN2P(dataToSend: any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const url = `${this.baseUrl_N2P}/createpittrench`
    return this.http.post(url, dataToSend, { headers })
  }

  checkBjlCapacityN2P(dataToSend: any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const url = `${this.baseUrl_N2P}/checkbjlcapacityn2p`
    return this.http.post(url, dataToSend, { headers })
  }

  newBjl(dataToSend: any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const url = `${this.baseUrl_N2P}/new_bjl`
    return this.http.post(url, dataToSend, { headers })
  }
 
  newSPL(dataToSend: any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const url = `${this.baseUrl_N2P}/view_smp_creation`
    return this.http.post(url, dataToSend, { headers })
  }
  
  newFJLSPL(dataToSend: any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const url = `${this.baseUrl_N2P}/new_fjl_spl_creation`
    return this.http.post(url, dataToSend, { headers })
  }
  
  onDataCleaning(dataToSend: any, queryString: any): Observable<any> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const url = `${this.baseUrl_N2P}/dfn_dataclean` + queryString
    return this.http.post(url, dataToSend, { headers })
  }
  
  sheet_validation(dataToSend: any, options?: any): Observable<any> {
  const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  const url = `${this.baseUrl_N2P}/sheet_validation`;
  const httpOptions = { headers, ...options };
  return this.http.post(url, dataToSend, httpOptions);
}

  //// Aerial APIs
  initiatemapAerial(queryString: string): Observable<any> {
    const url = `${this.baseUrl_Aerial}/initiateaerial` + queryString;
    console.log(url)
    return this.http.post(url, {});
  } 

  
/* TYPE2 APIs */
  //TODO: rename createmap to initiatemap 
  initiatemapinfodesigntype2(dataToSend: any, options?: any): Observable<any> {
  const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  const url = `${this.baseUrl_TYPE2}/initiatemapinfodesigntype2` + dataToSend;;
  const httpOptions = { headers, ...options };
  return this.http.post(url, dataToSend, httpOptions);
  } 
  sheet_validation_sd1(dataToSend: any, options?: any): Observable<any> {
  const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  const url = `${this.baseUrl_TYPE2}/sheet_validation_sd1`;
  const httpOptions = { headers, ...options };
  return this.http.post(url, dataToSend, httpOptions);
}
}

